export default __webpack_public_path__ + "static/media/calendar.e1b8bf63.svg";